import React from "react";
import ResourceListPage from "components/ResourceListPage";

const Categories = () => (
  <ResourceListPage resource="categories" title="Categories" />
);

export default Categories;
